import { Component } from '@angular/core';
import {Router} from "@angular/router";

@Component({
  selector: 'proposal-signed',
  templateUrl: './proposal-signed.component.html',
  styleUrls: ['./proposal-signed.component.css']
})
export class ProposalSignedComponent {

  constructor(private router: Router) {
  }

  chooseForm(): void {
    this.router.navigate(['/choose-form']);
  }
}
